import FJCommunityAITools from './FJCommunityAITools';
import useLocalStore from '../../../../hooks/useLocalStore';
import PropTypes from 'prop-types';
import { AI_COMMUNITY_AI_TOOLS_DATA } from '../../../../config/dataConfig/FJCommunityData';
const FJCommunityAIToolsContainer = props => {
    const { active } = props;
    useLocalStore();

    return <FJCommunityAITools active={active} data={AI_COMMUNITY_AI_TOOLS_DATA} />;
};

FJCommunityAIToolsContainer.propTypes = {
    active: PropTypes.bool.isRequired,
};

export default FJCommunityAIToolsContainer;
